(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/reverse', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/reverse'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.reverse, global.convert);
    global.reverse = mod.exports;
  }
})(this, function (exports, _reverse2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.reverse = undefined;

  var _reverse3 = _interopRequireDefault(_reverse2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array reversing the elements from the former array.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @return {Object} Returns the updated object.
   * @example reverse({ nested: { prop: [1, 2, 3] } }, 'nested.prop') // => { nested: { prop: [3, 2, 1] } }
   * @see {@link https://lodash.com/docs#reverse|lodash.reverse} for more information.
   * @since 0.3.0
   */
  var reverse = (0, _convert.convert)(_reverse3.default);
  exports.reverse = reverse;
  exports.default = reverse;
});